"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getIsAuthenticated = exports.getIsAuthenticated = function getIsAuthenticated(state) {
  var user = state.oidc.user;
  return Boolean(user && !user.expired);
};

var getOauthToken = exports.getOauthToken = function getOauthToken(state) {
  return state.session.oauthToken;
};

var getSessionIsLoadingUser = exports.getSessionIsLoadingUser = function getSessionIsLoadingUser(state) {
  return state.oidc.isLoadingUser;
};

var getSessionUser = exports.getSessionUser = function getSessionUser(state) {
  return state.oidc.user;
};

var getSessionUserToken = exports.getSessionUserToken = function getSessionUserToken(state) {
  return state.oidc.user.access_token;
};